import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["data-base-equalizer-element-part"]


export default /*@__PURE__*/_defineComponent({
  __name: 'BaseEqualizerElementPart',
  props: {
  name: {
    type: String,
    default: null,
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", { "data-base-equalizer-element-part": __props.name }, [
    _renderSlot(_ctx.$slots, "default")
  ], 8, _hoisted_1))
}
}

})